module.exports = __webpack_public_path__ + "04_short_yellow.dce7b38a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/04_short_yellow.png
// module id = od31
// module chunks = 0